import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Read-only fallback for toggle columns that do not provide a custom cell template.
 * Interactive toggles should override this via TreelistCustomCellDirective in the parent.
 */
@Component({
  selector: 'app-treelist-toggle-cell',
  template: `
    <div class="switch switch-primary switch-lg switch-disabled-transition d-inline mx-auto">
      <input
        type="checkbox"
        [checked]="value"
        [disabled]="true"
        (click)="$event.preventDefault()"
      />
      <label class="cr"></label>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreelistToggleCellComponent {
  @Input() value: boolean = false;
}
